// extracted by mini-css-extract-plugin
module.exports = {"field":"field_2i5Lt","label":"label_2WJvQ","number":"number_3V3RX"};